export default __webpack_public_path__ + "static/media/Applyboard.2f02cf7c.png";